import { Link } from 'react-router';

import type { SurfaceSlotV1 } from '~/api/v1/mall/surface/surface-name';
import { DATA_AREAS } from '~/constants/data-areas';

export type TopFullBannerStyles = {
  box: string;
  img?: string;
};

type Props = {
  styles: TopFullBannerStyles;
  topFullBanner?: SurfaceSlotV1;
};

export const TopFullBanner = (props: Props) => {
  const { styles, topFullBanner } = props;

  if (!topFullBanner) return null;

  const type = topFullBanner.slot_type;
  let path: string | undefined;
  if (type === 'shop') {
    path = `/shop/${topFullBanner.campaign_id}`;
  } else if (type === 'feature') {
    path = `/event/${topFullBanner.event_id}`;
  } else if (type === 'external') {
    path = `${topFullBanner.external_url}`;
  }

  if (type === 'other' || !path) {
    return <img className={styles.box} src={topFullBanner.image1_path} alt={topFullBanner.title} />;
  }

  return (
    <Link
      to={path}
      className={styles.box}
      target={type === 'external' ? '_blank' : undefined}
      rel={type === 'external' ? 'noopener noreferrer' : undefined}
      data-area={DATA_AREAS.TOP_FULL_BANNER}>
      <img src={topFullBanner.image1_path} alt={topFullBanner.title} className={styles.img} />
    </Link>
  );
};
